import React from 'react';

const Step7Documents = ({
  setCurrentStep,
  handleSubmitStep6,
  isSubmitting,
  file1Selected,
  setFile1Selected,
  file2Selected,
  setFile2Selected,
  submitError
}) => {
  return (
    <div className="modal_content_body">
      <h3 className="ppt_form_title mb-5 text-center">Step 6: Upload Documents</h3>
      <div className="ppt_input_style mb-4">
        <label className="">Bank statement with your name and address, dated within the last month.</label>
        <div className="d-flex align-items-center gap-2">
          <div className="form-control p-2 d-flex align-items-center gap-2">
            {file1Selected && (
              <img
                src={process.env.PUBLIC_URL + '/assets/img/icon_close_fill.svg'}
                alt=""
                style={{ width: '22px', filter: 'grayscale(1)', opacity: '0.5' }}
                className="pointer"
                onClick={(e) => {
                  e.preventDefault();
                  setFile1Selected(false);
                  document.getElementById('file1Name').textContent = 'No file selected';
                  document.getElementById('file1Input').value = '';
                }}
              />
            )}
            <span id="file1Name">No file selected</span>
            {file1Selected && (
              <img
                src={process.env.PUBLIC_URL + '/assets/img/icon_check_fill.svg'}
                className="ms-auto"
                alt=""
                style={{ width: '20px' }}
              />
            )}
          </div>
          <label className="pointer">
            <img src={process.env.PUBLIC_URL + '/assets/img/icon_upload.svg'} alt="" border="0" />
            <input
              id="file1Input"
              type="file"
              className="d-none"
              onChange={(e) => {
                if (e.target.files[0]) {
                  setFile1Selected(true);
                  document.getElementById('file1Name').textContent = e.target.files[0].name;
                }
              }}
            />
          </label>
        </div>
      </div>
      <div className="ppt_input_style mb-4">
        <label className="">Utility bill (internet, water, or electricity) with your address, dated within the last three months.</label>
        <div className="d-flex align-items-center gap-2">
          <div className="form-control p-2 d-flex align-items-center gap-2">
            {file2Selected && (
              <img
                src={process.env.PUBLIC_URL + '/assets/img/icon_close_fill.svg'}
                alt=""
                style={{ width: '22px', filter: 'grayscale(1)', opacity: '0.5' }}
                className="pointer"
                onClick={(e) => {
                  e.preventDefault();
                  setFile2Selected(false);
                  document.getElementById('file2Name').textContent = 'No file selected';
                  document.getElementById('file2Input').value = '';
                }}
              />
            )}
            <span id="file2Name">No file selected</span>
            {file2Selected && (
              <img
                src={process.env.PUBLIC_URL + '/assets/img/icon_check_fill.svg'}
                className="ms-auto"
                alt=""
                style={{ width: '20px' }}
              />
            )}
          </div>
          <label className="pointer">
            <img src={process.env.PUBLIC_URL + '/assets/img/icon_upload.svg'} alt="" border="0" />
            <input
              id="file2Input"
              type="file"
              className="d-none"
              onChange={(e) => {
                if (e.target.files[0]) {
                  setFile2Selected(true);
                  document.getElementById('file2Name').textContent = e.target.files[0].name;
                }
              }}
            />
          </label>
        </div>
      </div>
      {submitError && (
        <div className="alert alert-danger mb-4">
          {submitError}
        </div>
      )}
      <div className="d-flex justify-content-end gap-3 pt-4 kyc_btns">
        <button onClick={() => setCurrentStep(6)} className="ppt_btn_secondary alt text-dark">Back</button>
        <button
          onClick={handleSubmitStep6}
          className="ppt_btn_primary alt"
          disabled={!file1Selected || !file2Selected || isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Continue'}
        </button>
      </div>
    </div>
  );
};

export default Step7Documents;